import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "w-full flex flex-col" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-left font-bold text-2xl" }, "Dados de Acesso"),
  /*#__PURE__*/_createElementVNode("p", { class: "text-left text-sm text-gray-500" }, " Seu e-mail e senha será utilizado para entrar no aplicativo Minha Escala. ")
], -1)
const _hoisted_2 = { class: "flex flex-col w-full gap-2" }

import { ref } from 'vue'
import { storeToRefs } from 'pinia'
import { mdiEye, mdiEyeOff } from '@mdi/js'
import { useDoctorRegistryStore } from '@/pinia-store/useDoctorRegistryStore'
import { rules } from '@/utils/rules'
import Network from '@/Network'
import { validateEmail } from '@/utils/validation'
import { getApiErrorMessage } from '@/utils/apiError'


export default /*#__PURE__*/_defineComponent({
  __name: 'UserData',
  setup(__props) {

const doctorRegistryStore = useDoctorRegistryStore()
const { userDataForm, userDataFormRef } = storeToRefs(doctorRegistryStore)

const showPassword = ref(false)
const showRepeatPassword = ref(false)
const emailIsValid = ref<string>('')

const verifyEmail = async () => {
  if (!validateEmail(userDataForm.value.email)) return
  try {
    emailIsValid.value = ''
    const data = await Network.user.verifyEmail(userDataForm.value.email)
    if (data.emailIsAlreadyInUse) {
      emailIsValid.value = 'Este email já está em uso!'
    }
  } catch (error) {
    // Erro inline no campo (não toast: dispara a cada digitação). O ServiceError
    // do UserService.verifyEmail traz a mensagem do backend.
    // Fallback só defensivo (o service sempre lança ServiceError); mesmo texto do service.
    emailIsValid.value = getApiErrorMessage(error, 'Não foi possível verificar o e-mail.')
  }
}

const rulesSpecific = {
  confirmPassword: (value: string) => {
    return value === userDataForm.value.password || 'As senhas não coincidem!'
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_form = _resolveComponent("v-form")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createBlock(_component_v_form, {
    ref_key: "userDataFormRef",
    ref: userDataFormRef,
    id: "formDoctorSignUpPesonalData",
    class: "w-full flex gap-7 items-center flex-col rounded overflow-hidden mt-5 mb-4"
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_v_text_field, {
          modelValue: _unref(userDataForm).email,
          "onUpdate:modelValue": [
            _cache[0] || (_cache[0] = ($event: any) => ((_unref(userDataForm).email) = $event)),
            verifyEmail
          ],
          label: "* Email",
          class: "w-full",
          color: "primary20",
          variant: "outlined",
          onInput: _cache[1] || (_cache[1] = ($event: any) => (_unref(userDataForm).email = $event.target.value.toLowerCase())),
          rules: [_unref(rules).required, _unref(rules).email],
          error: !!emailIsValid.value,
          "error-messages": emailIsValid.value
        }, null, 8, ["modelValue", "rules", "error", "error-messages"]),
        _withDirectives(_createVNode(_component_v_text_field, {
          modelValue: _unref(userDataForm).phone,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(userDataForm).phone) = $event)),
          label: "* Telefone",
          class: "w-full",
          color: "primary20",
          variant: "outlined",
          rules: [_unref(rules).required, _unref(rules).phone]
        }, null, 8, ["modelValue", "rules"]), [
          [_directive_maska, '(##) #####-####']
        ]),
        _createVNode(_component_v_text_field, {
          modelValue: _unref(userDataForm).password,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(userDataForm).password) = $event)),
          label: "* Senha",
          class: "w-full",
          color: "primary20",
          variant: "outlined",
          type: showPassword.value ? 'text' : 'password',
          "onClick:appendInner": _cache[4] || (_cache[4] = ($event: any) => (showPassword.value = !showPassword.value)),
          "append-inner-icon": showPassword.value ? _unref(mdiEye) : _unref(mdiEyeOff),
          rules: [_unref(rules).required, _unref(rules).password]
        }, null, 8, ["modelValue", "type", "append-inner-icon", "rules"]),
        _createVNode(_component_v_text_field, {
          modelValue: _unref(userDataForm).confirmPassword,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(userDataForm).confirmPassword) = $event)),
          label: "* Confirmação da senha",
          class: "w-full",
          color: "primary20",
          variant: "outlined",
          type: showRepeatPassword.value ? 'text' : 'password',
          "onClick:appendInner": _cache[6] || (_cache[6] = ($event: any) => (showRepeatPassword.value = !showRepeatPassword.value)),
          "append-inner-icon": showRepeatPassword.value ? _unref(mdiEye) : _unref(mdiEyeOff),
          rules: [_unref(rules).required, rulesSpecific.confirmPassword]
        }, null, 8, ["modelValue", "type", "append-inner-icon", "rules"])
      ])
    ]),
    _: 1
  }, 512))
}
}

})